var render = function (_h,_vm) {var _c=_vm._c;return _vm._m(0)}
var staticRenderFns = [function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"life-loader"},[_c('div',{staticClass:"sk-wave"},[_c('img',{attrs:{"src":"/assets/img/loader.gif"}})])])}]

export { render, staticRenderFns }